import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import StoreMenu from "../StoreMenu";
import { PostStoreUsers } from "../../services/StoreUsers/PostStoreUsers";
import { formatDate } from "../../constants/DateUtil/DateUtil";
import ButtonLink from "../../ButtonLink";
import AdminMenu from "../AdminMenu";
import SupportAdminMenu from "../SupportAdminMenu";
import FinanceAdminMenu from "../FinanceAdminMenu";

const StoreUserProfile = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  const { userProfileData, userProfileRole } = getUserData();

  const userRole = userProfileRole;


  let formattedCreatedDate = userProfileData.createdDate
    ? formatDate(userProfileData.createdDate)
    : '';
  let formattedNextRenewalDate = userProfileData.nextRenewalOn
    ? formatDate(userProfileData.nextRenewalOn)
    : '';




  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                User Profile
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div>
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-between mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">
                  {(
                    userProfileData.firstName +
                    ' ' +
                    userProfileData.lastName
                  ).replace(/_/g, ' ')}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1 ">
          <div className="m-4 shadow-4">
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  User Role :
                </p>
                <p className="text-lg font-medium capitalize"> {userProfileData.role.replace(/_/g, ' ')}</p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Register On :
                </p>
                <p className="text-lg font-medium capitalize">
                  {formattedCreatedDate}
                </p>
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  User Id :
                </p>
                <p className="text-lg font-medium capitalize">
                  {userProfileData.userLoginId}
                </p>
              </div>
            </div>
            <div className="flex flex-1">
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Next Renewal Date :
                </p>
                <p className="text-lg font-medium capitalize">
                  {formattedNextRenewalDate}
                </p>
              </div>

              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#F8FFEE",
                }}
              >
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Account Status :
                </p>
                {userProfileData.enabled === true ? (
                  <div className="flex ">
                    <p className="text-lg font-medium capitalize mr-2">
                      Active{" "}
                    </p>
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                      }
                      style={{
                        height: 22,
                        width: 22,
                      }}
                    />
                  </div>
                ) : (
                  <div className="flex ">
                    <p className="text-lg font-medium capitalize mr-2">
                      DeActive{" "}
                    </p>
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                      }
                      style={{
                        height: 22,
                        width: 22,
                      }}
                    />
                  </div>
                )}
              </div>
              <div
                className="flex-1 px-3 py-1"
                style={{
                  backgroundColor: "#E2F4F8",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      {userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER" || userRole === "BY_FRANCHISE_ADMIN" ? (
        <AdminMenu setVisible={setVisible} visible={visible} />
      ) : userRole === "BY_SUPPORT_ADMIN" ? (
        <SupportAdminMenu setVisible={setVisible} visible={visible} />
      ) : userRole === "BY_ACCOUNTANT" ? (
        <FinanceAdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <>
          <StoreMenu setVisible={setVisible} visible={visible} />
          <ButtonLink />
        </>
      )}
    </div>
  );
};

export default StoreUserProfile;
